import React, { useState } from 'react'
import CustomTable from '../../../../components/BasicUI/CustomTable'
import { useDeleteRole, useRoles, useRolesFacet } from '../../../../config/query/roleQuery'
import { formatDateTime, formatDateTimeFromNow } from '../../../../config/helpers/dateHelper'
import APP_ICONS from '../../../../config/constants/icons'
import StatusBadge from '../../../../components/BasicUI/Badges/StatusBadge'
import Chronology from '../../../../components/BasicUI/DataBoxes/Chronology'
import { getFilters } from '../../../../config/helpers/filterHelper'
import TableInfoPopover from '../../../../components/BasicUI/Popovers/TableInfoPopover'
import LabelValuePair from '../../../../components/BasicUI/LabelValuePair'

const RoleList = ({ onEditModal }) => {

    const [query, setQuery] = useState({
        pageNo: 1,
        pageSize: 20,
    })

    const rolesQuery = useRoles(query)
    const rolesFacetQuery = useRolesFacet({})
    const deleteRoleQuery = useDeleteRole()

    const handleDelete = (id) => {
        deleteRoleQuery.mutateAsync(id)
            .then((response) => {
                rolesQuery.refetch()
                console.log(`Qualification deleted successfully: ${response}`)
            })
            .catch((error) => {
                console.log(`Error while deleting qualification: ${error}`)
            })
    }

    return (
        <CustomTable
            containerProps={{ mt: 5 }}
            searchPlaceholder="Search roles"
            filters={getFilters(rolesFacetQuery?.data)}
            head={[
                {
                    title: "Name",
                    extractor: "name",
                    align: "left",
                    component: (item) => (
                        <TableInfoPopover
                            data={item}
                            onEdit={(item) => onEditModal(item)}
                            onDelete={(id) => handleDelete(id)}
                            triggerOnClick={() => onEditModal(item)}
                        >
                            <LabelValuePair label="Description" value={item.description} />
                            <LabelValuePair label="Chapter" value={item.chapterName} />
                            <LabelValuePair label="Cohort" value={item.cohortName} />
                            <LabelValuePair label="Course" value={item.courseName} />
                            <LabelValuePair label="Qualification" value={item.qualificationName} />
                            <LabelValuePair
                                label="Status"
                                value={true}
                                valueComponent={
                                    <StatusBadge value={item.status} />
                                }
                            />
                            <LabelValuePair label="Created" value={formatDateTime(item.createdBy?.dateTime)} />
                            <LabelValuePair label="Last Updated" value={formatDateTime(item.updateBy?.dateTime)} />
                        </TableInfoPopover>
                    )
                },
                { title: "Status", extractor: "status", component: (item) => <StatusBadge value={item.status} /> },
                {
                    title: "Last Modified",
                    extractor: "lastModified",
                    component: (item) => <Chronology data={item} />
                },
                { title: "Actions", extractor: "actions" }
            ]}
            data={rolesQuery?.data?.results?.map((item) => {
                return {
                    ...item,
                    lastModified: item.updatedBy?.dateTime ? formatDateTimeFromNow(item.updatedBy?.dateTime) : formatDateTimeFromNow(item.createdBy?.dateTime),
                    actions: [
                        {
                            title: "Edit",
                            action: () => onEditModal(item),
                            icon: APP_ICONS.EDIT,
                            isEdit: true
                        },
                        {
                            title: "Delete",
                            action: handleDelete,
                            icon: APP_ICONS.BIN,
                            isDelete: true
                        }
                    ]
                }
            })}
            loading={rolesQuery?.isLoading}
            totalResults={rolesQuery?.data?.totalResults}
            totalPages={rolesQuery?.data?.totalPages}
            pageNo={query.pageNo}
            pageSize={query.pageSize}
            onQueryChange={(updatedQuery) => setQuery({ ...query, ...updatedQuery })}
            query={query}
            onRefresh={() => rolesQuery.refetch()}
            isRefreshing={rolesQuery?.isFetching}
        />
    )
}

export default RoleList